import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();
    const isListingsPage = location.pathname === '/listings' || location.pathname === '/listing' || location.pathname.startsWith('/profile');
    const isHomePage = location.pathname === '/';


    return (
        <>
            {/* Sticky Header */}
            <header className="fixed top-0 w-full z-50 bg-white/70 dark:bg-inverse-surface/70 backdrop-blur-md shadow-sm border-b border-outline-variant/30">
                <nav className="flex justify-between items-center px-gutter py-4 max-w-container-max mx-auto w-full">
                    {/* Mobile Hamburguer button & Brand Logo */}
                    <div className="flex items-center gap-4">
                        <button
                            onClick={() => setIsMenuOpen(!isMenuOpen)}
                            className="material-symbols-outlined text-primary text-[32px] md:hidden focus:outline-none"
                            aria-label="Toggle menu"
                        >
                            {isMenuOpen ? 'close' : 'menu'}
                        </button>
                        <div className="flex items-center gap-3">
                            <img alt="The Locksmith USA Logo" className="h-14 w-14 md:h-16 md:w-16 object-contain" src="https://lh3.googleusercontent.com/aida-public/AB6AXuBFAyegf68qs51EBcnvUtRow7b4Y-lc3sikeTyEWPAFK0TIFC6tjUCEsVRi2yEPUJhbMiToAusvLMo4PQk1YzxP93Gm2OBKwZdGeNJjI5ALpKGzsTBkzGd3ayd1RmfFEtTsaMzjeZQ_4IDalpUAHhPFPXtCcDdUHadpkIBs5JFTnoxKRLjsvI170LFKgyIrgcKNIB0n0u7xLwHFopG9fNKwGvnFZ2KiXYt0HcwctcgssuNcMKQ2u0CVxMPcuSPdG8EsuSsDoq6J5C8" />
                        </div>
                    </div>

                    {/* Desktop Nav Links */}
                    <div className="hidden md:flex gap-8 items-center">
                        <Link
                            to="/"
                            className={`${isHomePage ? 'text-primary font-bold border-b-2 border-secondary-container pb-1' : 'text-on-surface-variant hover:text-secondary'} transition-colors font-body-md text-body-md`}
                        >
                            Home
                        </Link>
                        <Link
                            to="/listings"
                            className={`${isListingsPage ? 'text-primary font-bold border-b-2 border-secondary-container pb-1' : 'text-on-surface-variant hover:text-secondary'} transition-colors font-body-md text-body-md`}
                        >
                            Listings
                        </Link>
                    </div>

                    {/* CTAs */}
                    <div className="flex items-center gap-4">
                       <Link
                            to="tel:1-800-555-LOCK"
                            className="bg-secondary-container text-on-secondary-container p-2 md:px-6 md:py-3 rounded-full font-button hover:opacity-90 transition-all shadow-md flex items-center justify-center gap-2"
                        >
                            <span className="material-symbols-outlined text-[20px] md:text-[24px]">call</span>
                            <span className="hidden md:inline">Emergency Call</span>
                        </Link>
                    </div>
                </nav>

                {/* Mobile Navigation Drawer */}
                {isMenuOpen && (
                    <div className="md:hidden absolute top-full left-0 w-full bg-white dark:bg-inverse-surface border-b border-outline-variant/30 shadow-lg px-gutter py-6 flex flex-col gap-4 z-40 transition-all duration-300 animate-fadeIn">
                        <Link
                            to="/"
                            onClick={() => setIsMenuOpen(false)}
                            className={`${isHomePage ? 'text-primary font-bold' : 'text-on-surface-variant'} font-body-md text-body-md py-2 border-b border-outline-variant/10`}
                        >
                            Home
                        </Link>
                        <Link
                            to="/listings"
                            onClick={() => setIsMenuOpen(false)}
                            className={`${isListingsPage ? 'text-primary font-bold' : 'text-on-surface-variant'} hover:text-secondary transition-colors font-body-md text-body-md py-2 border-b border-outline-variant/10`}
                        >
                            Listings
                        </Link>
                    </div>
                )}
            </header>
        </>
    )
}

export default Header